/*  MUI  */
import { CellContext, Row } from '@tanstack/react-table';

/*  Shared  */
import { Sources } from 'application/Shared/Components/Avatars';
import { Helpers } from 'application/Shared/Helpers';

/*  React  */
import React from 'react';

/**
 * Filter function for tenant application sources
 * @template TenantApp The type of the tenant application data
 * @param {Row<TenantApp>} row The row data from the table
 * @param {string} columnId The ID of the column being filtered
 * @param {string} filterValue The value to filter by
 * @returns {boolean} True if the row should be included in filtered results
 */
export function tenantAppSourcesFilterFn<TenantApp>(
    row: Row<TenantApp>,
    columnId: string,
    filterValue: string[]
): boolean {
    if (!filterValue || !filterValue?.length) return true;

    const filterValueArray = Array.isArray(filterValue)
        ? filterValue
        : [filterValue];

    if (filterValueArray.length === 0) return true;

    const sources = Helpers.getSources(row.original);
    return filterValueArray.some((source) => sources[source]);
}

/**
 * Component that renders a cell displaying tenant application sources
 * @template TData The type of data in the table
 * @param {Object} props Component props
 * @param {Object} props.row The row data from the table
 * @param {Object} props.rest Additional props to pass to the Sources component
 * @returns {JSX.Element} A Box component containing the Sources display
 */
export const TenantAppSourcesCell = <TData,>({
    row,
    ...rest
}: CellContext<TData, unknown>): JSX.Element => {
    const sources = Helpers.getSources(row.original);
    return <Sources sources={sources} max={3} {...rest} />;
};
